// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Onboarding Banner Styles */

.onboarding-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(
    90deg,
    var(--color-primary-idel) 0%,
    var(--color-additional-active-curious-blue) 100%
  );
  background: linear-gradient(
    90deg,
    var(--color-primary-idel) 0%,
    var(--color-additional-active-curious-blue) 100%
  );
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(69, 99, 199, 0.2);
  margin: 12px 0;
  animation: slide-in 0.3s ease-out;
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.onboarding-banner__content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.onboarding-banner__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-grey-100);
  color: var(--color-grey-100);
}

.onboarding-banner__text {
  color: var(--color-grey-100);
  color: var(--color-grey-100);
}

.onboarding-banner__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--color-grey-100);
  color: var(--color-grey-100);
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.onboarding-banner__close:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.onboarding-banner__close:active {
  background-color: rgba(255, 255, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/OnboardingBanner.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB;;;;GAIC;EACD;;;;GAIC;EACD,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":["/* Onboarding Banner Styles */\n\n.onboarding-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: linear-gradient(\n    90deg,\n    var(--color-primary-idel) 0%,\n    var(--color-additional-active-curious-blue) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    var(--color-primary-idel) 0%,\n    var(--color-additional-active-curious-blue) 100%\n  );\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(69, 99, 199, 0.2);\n  margin: 12px 0;\n  animation: slide-in 0.3s ease-out;\n}\n\n@keyframes slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.onboarding-banner__content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.onboarding-banner__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n}\n\n.onboarding-banner__text {\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n}\n\n.onboarding-banner__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.onboarding-banner__close:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.onboarding-banner__close:active {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
